import styled from "styled-components";

export const Main = styled.main`
  position: relative;
  margin: 0;
  padding-bottom: 0;
  overflow: hidden;
`;
